export { BrandPage } from './brand-page'
